import {
	MahnwesenFilters,
	PaymentReminderCandidate,
	ReminderCandidateMode,
} from "../payment-reminder.types";

// "Fällig" filters on the stage about to be created, the other views on the current one.
export const filterReminderCandidates = (
	candidates: PaymentReminderCandidate[],
	{ search, recipientId, stage }: MahnwesenFilters,
	mode: ReminderCandidateMode
) => {
	const needle = search.trim().toLowerCase();
	return candidates.filter(
		(candidate) =>
			(!needle ||
				candidate.doc_number.toLowerCase().includes(needle) ||
				candidate.recipient_name.toLowerCase().includes(needle)) &&
			(recipientId === null ||
				candidate.client_id === recipientId ||
				candidate.guarantor_id === recipientId) &&
			(stage === null ||
				(mode === "due"
					? candidate.next_stage
					: candidate.current_stage) === stage)
	);
};
